import React, { useEffect, useRef } from "react";
import "./index.scss";
import { getTournaments } from "../../services/tournaments";
import Table from "../WhatsOnTable";
import Hero from "../GernericHero";
import { formatDate, setResponsiveImage } from "../../helpers";
import {
  WhatsOnHeroProps,
  Dates,
  AdvancedFilters,
  SortCriteria
} from "./types";
import moment from "moment";
import {
  CourtSurface,
  dropdownItemSelected,
  HostDetails,
  START_DATE,
  ALL
} from "../WhatsOnTable/types";
import { getResultsRoundUp } from "../../services/resultsroundup";
import "url-search-params-polyfill";
import { dropdownItem } from "packages/static/Dropdown/types";
import { refreshURLState, parseString } from "./helpers";
import Banner from "../../static/AdBanner";
import { checkImage } from "../../helpers";

function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const WhatsOnHero = ({
  tourOptions = [],
  mobileImage = "",
  tabletImage = "",
  desktopImage = "",
  heading,
  subheading,
  brandLogo,
  sponsorLogo,
  sponsorLink,
  tourCode,
  isBeach,
  pagerTake = 100,
  results = false,
  adBannersTop,
  adBannersFooter
}: WhatsOnHeroProps) => {
  let searchStartDate = new URLSearchParams(location.search).getAll(
    "startdate"
  )[0];
  let circuitValue = new URLSearchParams(location.search).getAll(
    "circuitcode"
  )[0];
  let [circuitCode, updateCircuit] = React.useState<{
    value: string;
    filtersLoaded: boolean;
  }>({ value: circuitValue || "", filtersLoaded: false });
  let circuit = { circuitCode, updateCircuit };
  let [titleSearchTerm, setTitleSearchTerm] = React.useState("");
  let [searchResults, setSearchResults] = React.useState({
    totalItems: 0,
    items: []
  });
  let [isLoading, setIsLoading] = React.useState(true);
  let [filtersLoaded, loadfilters] = React.useState(false);
  let [isProgressiveLoading, setIsProgressiveLoading] = React.useState(false);
  let [reset, setReset] = React.useState(false);
  let [takeValue, setTake] = React.useState(pagerTake);
  let [advancedFilters, setAdvancedFilters] = React.useState<AdvancedFilters>({
    courtSurfaces: [],
    courtDoorness: [],
    categories: [],
    matchTypes: [],
    shouldUpdateData: false,
    ageCategories: [],
    playerTypes: [],
    grandSlams: [],
    tennisCategories: [],
    drawFormat: []
  });

  const [hostOptions, setHostOptions] = React.useState<HostDetails[]>([]);
  const [sortCriteria, setSortCriteria] = React.useState<SortCriteria>({
    orderFilter: START_DATE,
    isAscending: true
  });
  const nationCodes = hostOptions
    .reduce((accumulator, host) => {
      if (host.type === "nation" && host.active) {
        return accumulator + host.code + ",";
      } else {
        return accumulator;
      }
    }, "")
    .slice(0, -1);

  const zoneCode = hostOptions
    .reduce((accumulator, host) => {
      if (host.type === "zone" && host.active) {
        return accumulator + host.code + ",";
      } else {
        return accumulator;
      }
    }, "")
    .slice(0, -1);

  let doornessString = "";
  if (advancedFilters.courtDoorness.length) {
    doornessString = parseString(advancedFilters.courtDoorness);
  }
  doornessString = doornessString.slice(0, -1);

  let drawFormatString = "";
  if (advancedFilters.drawFormat && advancedFilters.drawFormat.length > 0) {
    const item = advancedFilters.drawFormat.find(item => item.selected);
    drawFormatString = item ? item.value.toString() : "";
  }

  let courtSurfacesString = "";

  if (advancedFilters.courtSurfaces.length) {
    courtSurfacesString = advancedFilters.courtSurfaces.reduce(
      (accumulator: string, currentValue: CourtSurface) => {
        if (currentValue.active) {
          return `${accumulator}${currentValue.code},`;
        } else {
          return accumulator;
        }
      },
      ""
    );
  }
  courtSurfacesString = courtSurfacesString.slice(0, -1);

  let categoriesString = "";
  if (advancedFilters.categories.length) {
    categoriesString = advancedFilters.categories.reduce(
      (accumulator: string, currentValue: dropdownItemSelected) => {
        if (currentValue.selected) {
          return `${accumulator}${currentValue.value},`;
        } else {
          return accumulator;
        }
      },
      ""
    );
  }
  categoriesString = categoriesString.slice(0, -1);

  const isFullYearFlag =
    searchStartDate === new Date(searchStartDate).getFullYear().toString();

  const resultsDefaultDates = {
    startDate: !searchStartDate
      ? moment()
          .startOf("week")
          .subtract(1, "day")
      : isFullYearFlag
      ? moment(new Date(searchStartDate)).startOf("year")
      : moment(
          new Date(
            `${
              moment(new Date(searchStartDate)).isValid()
                ? moment(new Date(searchStartDate))
                    .startOf("week")
                    .toString()
                : moment().startOf("week")
            }`
          )
        ),
    endDate: !searchStartDate
      ? moment()
          .endOf("week")
          .subtract(1, "day")
      : isFullYearFlag
      ? moment(new Date(searchStartDate)).endOf("year")
      : moment(
          new Date(
            `${
              moment(new Date(searchStartDate)).isValid()
                ? moment(new Date(searchStartDate))
                    .endOf("week")
                    .toString()
                : moment().endOf("week")
            }`
          )
        )
  };

  const isFullYear =
    searchStartDate && searchStartDate.toString().split("-").length === 1;

  let [dateValue, setDates] = React.useState<Dates>(
    results
      ? resultsDefaultDates
      : {
          startDate: !searchStartDate
            ? moment().startOf("month")
            : moment(
                new Date(
                  `${
                    moment(`${searchStartDate}-01`).month() < 12
                      ? searchStartDate
                      : formatDate(new Date()).rawYearMonth
                  }-01`
                )
              ),
          endDate: !searchStartDate
            ? moment().endOf("month")
            : !isFullYear
            ? moment(
                new Date(
                  `${
                    moment(`${searchStartDate}`).month() < 12
                      ? searchStartDate
                      : formatDate(new Date()).rawYearMonth
                  }`
                )
              ).endOf("month")
            : moment(
                new Date(
                  `${
                    moment(`${searchStartDate}`).month() < 12
                      ? searchStartDate
                      : formatDate(new Date()).rawYearMonth
                  }`
                )
              ).endOf("year")
        }
  );

  let [searchNationValue, updateSearchNationValue] = React.useState("");

  let [loadingError, setLoadingError] = React.useState(false);
  searchNationValue = searchNationValue ? searchNationValue : "";

  const advanced = { advancedFilters, setAdvancedFilters, ...circuit };
  const filters = { filtersLoaded, loadfilters };
  const nation = { searchNationValue, updateSearchNationValue };
  const hosts = { hostOptions, setHostOptions };
  const take = { takeValue, setTake };
  const dates = { dateValue, setDates };
  const titleSearchHook = { titleSearchTerm, setTitleSearchTerm };
  const loading = { isLoading, setIsLoading, loadingError, setLoadingError };
  const sort = { sortCriteria, setSortCriteria };
  const progressiveLoading = { isProgressiveLoading, setIsProgressiveLoading };
  const dateSelection: any = Object.keys({ ...dates.dateValue }).reduce(
    (obj, key) => {
      obj[key] = formatDate(dates.dateValue[key]).raw;
      return obj;
    },
    {}
  );

  const localErrorHandling = () => {
    setIsLoading(false);
    setLoadingError(true);
  };

  const heroProps = {
    heading,
    subheading,
    brandLogo,
    sponsorLogo,
    sponsorLink,
    mobileImage,
    tabletImage,
    desktopImage,
    isBeach,
    tourCode
  };

  // handle component update side effects on update
  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [searchResults, reset]);

  const prevDates: any = usePrevious(dateValue);

  const renderUpdate = (force = false) => {
    const showFullYear =
      dateValue.startDate &&
      dateValue.endDate &&
      dateValue.startDate.month() === 0 &&
      dateValue.endDate.month() === 11
        ? true
        : false;

    const handleEvent = (res: any) => {
      if (force && titleSearchTerm.length) {
        const searchYear = formatDate(dateValue.startDate).rawYear;
        const searchMonth = formatDate(dateValue.startDate).rawMonth;
        const payload = {
          event: "tournamentSearch",
          searchYear,
          searchMonth,
          searchNation: `${
            nationCodes && nationCodes.length ? nationCodes + "," : ""
          }${zoneCode}`,
          searchTerm: titleSearchTerm
        };
        console.log("GA tournamentSearch", payload);
        //@ts-ignore
        dataLayer.push(payload);
      }
      setIsLoading(false);
      if (res.totalItems == 0) {
        if (loadingError) setLoadingError(false);

        setSearchResults({
          totalItems: 0,
          items: []
        });
      } else {
        setSearchResults(res);
        setReset(true);
      }
    };

    const params = {
      q: titleSearchTerm,
      take: take.takeValue,
      tourCode,
      zoneCode,
      nationCodes,
      doorness: advancedFilters.courtDoorness.every(op => op.active)
        ? ""
        : advancedFilters.courtDoorness.filter(op => op.active)[0].code,
      surfaceCodes: advancedFilters.courtSurfaces.every(op => op.active)
        ? ""
        : courtSurfacesString,
      startDate: formatDate(dateValue.startDate).raw,
      endDate: formatDate(dateValue.endDate).raw,
      categories: categoriesString === ALL ? "" : categoriesString,
      isOrderAscending: sortCriteria.isAscending,
      orderField: sortCriteria.orderFilter,
      drawFormat: drawFormatString === ALL ? "" : drawFormatString
    };

    refreshURLState({
      date: moment(formatDate(dateValue.startDate).raw),
      showFullYear: showFullYear,
      results: results,
      filters: advancedFilters,
      circuitCode: circuitCode.value
    });

    setIsLoading(true);

    let areDatevaluesDifferent = true;
    if (prevDates !== undefined) {
      if (
        prevDates.startDate.isSame(dateValue.startDate, "day") ||
        (prevDates.endDate !== null &&
          prevDates.endDate.isSame(dateValue.endDate, "day"))
      ) {
        areDatevaluesDifferent = false;
      }
    }

    if (areDatevaluesDifferent) {
      categoriesString = ALL;
    }

    let additionalProps = {};
    if (results) {
      additionalProps = {
        matchType: advancedFilters.matchTypes.filter(
          (mt: dropdownItem) => mt.selected
        ).length
          ? advancedFilters.matchTypes.filter(
              (mt: dropdownItem) => mt.selected
            )[0].value
          : "",
        playerType: advancedFilters.playerTypes.filter(
          (pt: dropdownItem) => pt.selected
        ).length
          ? advancedFilters.playerTypes.filter(
              (pt: dropdownItem) => pt.selected
            )[0].value
          : "",
        ageCategories: advancedFilters.ageCategories.filter(
          (ageCat: dropdownItem) => ageCat.selected
        ).length
          ? advancedFilters.ageCategories.filter(
              (ageCat: dropdownItem) => ageCat.selected
            )[0].value
          : "",
        grandSlams: advancedFilters.grandSlams.filter(
          (grandSlam: dropdownItem) => grandSlam.selected
        ).length
          ? advancedFilters.grandSlams.filter(
              (grandSlam: dropdownItem) => grandSlam.selected
            )[0].value
          : ""
      };

      if (
        advancedFilters.tennisCategories &&
        advancedFilters.tennisCategories.length
      ) {
        additionalProps = {
          ...additionalProps,
          tennisCategories: advancedFilters.tennisCategories.filter(
            (t: dropdownItem) => t.selected
          )[0].value
        };
      }

      getResultsRoundUp({
        ...params,
        tourCode: circuitCode.value,
        ...additionalProps
      })
        .then(handleEvent)
        .catch(localErrorHandling);
    } else {
      getTournaments(params)
        .then(handleEvent)
        .catch(localErrorHandling);
    }
  };

  useEffect(() => {
    if (advancedFilters.shouldUpdateData) {
      renderUpdate();
    }
  }, [advancedFilters, filtersLoaded, zoneCode, nationCodes, sortCriteria]);

  useEffect(() => {
    if (advancedFilters.shouldUpdateData) {
      renderUpdate(true);
    }
  }, [titleSearchTerm]);

  useEffect(() => {
    setResponsiveImage({
      tabletImage,
      mobileImage,
      desktopImage,
      elClassName: "whatson-hero"
    });
  }, []);

  const areNoResults = !isLoading && searchResults.totalItems === 0;
  const topBanners = adBannersTop;
  const bottomBanners = adBannersFooter;

  return (
    <>
      {!results ? <Hero {...heroProps} /> : null}
      {topBanners && topBanners.length ? (
        <div className={`whatson-hero__ad-banner-container`}>
          <div
            className={`page-section__inner whatson-hero__ad-banner-wrapper banner-length--${topBanners.length}`}
          >
            {topBanners.map(b => {
              const props = {
                ...b,
                imgDesktopURL:
                  checkImage({ images: b.imageUrls || [], size: "Large" }) ||
                  "",
                imgMobileURL:
                  checkImage({ images: b.imageUrls || [], size: "Small" }) || ""
              };
              return <Banner {...props} />;
            })}
          </div>
        </div>
      ) : null}
      <Table
        results={results}
        {...advanced}
        {...nation}
        {...take}
        {...dates}
        {...titleSearchHook}
        {...loading}
        {...progressiveLoading}
        {...hosts}
        {...sort}
        {...filters}
        areNoResults={areNoResults}
        tourCode={tourCode}
        reset={reset}
        tourOptions={tourOptions}
        dateSelection={dateSelection}
        getData={(data: any) => {
          const apiData = {
            ...data,
            doorness: advancedFilters.courtDoorness.every(op => op.active)
              ? ""
              : advancedFilters.courtDoorness.filter(op => op.active)[0].code,
            surfaceCodes: advancedFilters.courtSurfaces.every(op => op.active)
              ? ""
              : courtSurfacesString,
            categories: categoriesString === ALL ? "" : categoriesString,
            zoneCode,
            nationCodes,
            isOrderAscending: sortCriteria.isAscending,
            orderField: sortCriteria.orderFilter
          };

          const eventHandler = (res: any) => {
            if (loadingError) setLoadingError(false);
            return new Promise(resolve => resolve(res));
          };

          if (results) {
            let additionalProps = {
              doorness: advancedFilters.courtDoorness.every(op => op.active)
                ? ""
                : advancedFilters.courtDoorness.filter(op => op.active)[0].code,
              matchType: advancedFilters.matchTypes.filter(
                (mt: dropdownItem) => mt.selected
              ).length
                ? advancedFilters.matchTypes.filter(
                    (mt: dropdownItem) => mt.selected
                  )[0].value
                : "",
              playerType: advancedFilters.playerTypes.filter(
                (pt: dropdownItem) => pt.selected
              ).length
                ? advancedFilters.playerTypes.filter(
                    (pt: dropdownItem) => pt.selected
                  )[0].value
                : "",
              ageCategories: advancedFilters.ageCategories.filter(
                (ageCat: dropdownItem) => ageCat.selected
              ).length
                ? advancedFilters.ageCategories.filter(
                    (ageCat: dropdownItem) => ageCat.selected
                  )[0].value
                : "",
              grandSlams: advancedFilters.grandSlams.filter(
                (grandSlam: dropdownItem) => grandSlam.selected
              ).length
                ? advancedFilters.grandSlams.filter(
                    (grandSlam: dropdownItem) => grandSlam.selected
                  )[0].value
                : ""
            };

            return getResultsRoundUp({
              ...apiData,
              tourCode: circuitCode.value,
              ...additionalProps
            })
              .then(eventHandler)
              .catch(localErrorHandling);
          } else {
            return getTournaments(apiData)
              .then(eventHandler)
              .catch(localErrorHandling);
          }
        }}
        searchStartDate={searchStartDate}
        tournamentSearchResults={searchResults}
      />
      {bottomBanners && bottomBanners.length ? (
        <div className={`whatson-hero__ad-banner-container bottom`}>
          <div
            className={`page-section__inner whatson-hero__ad-banner-wrapper banner-length--${bottomBanners.length}`}
          >
            {bottomBanners.map(b => {
              const props = {
                ...b,
                imgDesktopURL:
                  checkImage({ images: b.imageUrls || [], size: "Large" }) ||
                  "",
                imgMobileURL:
                  checkImage({ images: b.imageUrls || [], size: "Small" }) || ""
              };
              return <Banner {...props} />;
            })}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default WhatsOnHero;
